import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import SearchModal from "@/components/SearchModal";
import CountrySelect from "@/components/CountrySelect";
import CategorySelect from "@/components/CategorySelect";
import api from "@/lib/api";

export default function StoreLayout({ children }) {
  const { storefront, country, entered } = useApp();
  const [countryOpen, setCountryOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [content, setContent] = useState({});
  const { pathname } = useLocation();

  useEffect(() => { api.get(`/storefront/${storefront}/bootstrap`).then((r) => setContent(r.data.content || {})).catch(() => {}); }, [storefront]);
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div style={{ background: "var(--ev-bg)", minHeight: "100vh" }}>
      <CountrySelect open={countryOpen} forceOpen={!country} onClose={() => setCountryOpen(false)} />
      {country && !entered && <CategorySelect />}
      <Header onOpenCountry={() => setCountryOpen(true)} onOpenSearch={() => setSearchOpen(true)} />
      <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
      <main>{children}</main>
      <Footer content={content} onOpenCountry={() => setCountryOpen(true)} />
      <CartDrawer />
    </div>
  );
}
